import { render } from "./PhaseProofOfWorkModal.vue?vue&type=template&id=5c6afb27&scoped=true&ts=true"
import script from "./PhaseProofOfWorkModal.vue?vue&type=script&lang=ts"
export * from "./PhaseProofOfWorkModal.vue?vue&type=script&lang=ts"

import "./PhaseProofOfWorkModal.vue?vue&type=style&index=0&id=5c6afb27&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c6afb27"]])

export default __exports__